import useWindowSize from '../../hooks/useWindowSize';
import GestaoLayout from '../GestaoLayout';
import MobileLayout from '../MobileLayout';

const ResponsiveLayout = ({ children }) => {
  const windowSize = useWindowSize();

  const width = windowSize.width ?? (typeof window !== 'undefined' ? window.innerWidth : undefined);
  const isMobile = typeof width === 'number' ? width < 992 : false;

  const Layout = isMobile ? MobileLayout : GestaoLayout;

  return <Layout>{children}</Layout>;
};

export default ResponsiveLayout;
